<ng-container *ngIf="passengerWithDetails$ | async as passenger">
  <div class="flex flex--middle mr-small-b">
    <h3 class="nordic-blue-900-text font-heading-3">{{ passenger.firstName }} {{ passenger.lastName }}</h3>
  </div>

  <div>
    <button
      [attr.id]="'apis-' + passenger.id"
      [attr.aria-controls]="'apis-content-' + passenger.id"
      [attr.aria-expanded]="expandOpen"
      [attr.aria-label]="
        (expandOpen ? 'MMB.apis.passenger.closeDetails' : 'MMB.apis.passenger.openDetails') | finLocalization
      "
      class="fill flex no-outline"
      (click)="expandOpen = !expandOpen"
    >
      <div class="btn-content fill flex flex--space-between">
        <span class="flex flex--top ms-xsmall-r fill">
          <fcom-icon
            class="icon-medium ms-xsmall-r"
            [name]="passenger.completed ? SvgLibraryIcon.CHECKMARK : SvgLibraryIcon.ALERT_BLOCK"
            [ngClass]="{ 'birch-900-text': passenger.completed, 'error-900-text': !passenger.completed }"
          ></fcom-icon>
          <span class="flex-1 regular-type font-body-1 flex align-left flex--wrap">
            {{
              (passenger.completed ? 'MMB.apis.passenger.completed' : 'MMB.apis.passenger.notCompleted')
                | finLocalization
            }}
          </span>
        </span>

        <fcom-icon
          class="flex-1 flex--nogrow rotate icon-medium nordic-blue-900-text"
          [class.rotate-active]="expandOpen"
          [name]="SvgLibraryIcon.CHEVRON_DOWN"
        ></fcom-icon>
      </div>
    </button>
    <fcom-expand
      class="block"
      [open]="expandOpen"
      [ariaId]="'apis-content-' + passenger.id"
      [ariaLabelledBy]="'apis-' + passenger.id"
    >
      <fin-apis-status-row
        *ngFor="let info of passenger.information"
        [completed]="info.completed"
        [translationKey]="'MMB.apis.passenger.' + info.name"
      ></fin-apis-status-row>
    </fcom-expand>

    <div class="align-right pr-small-t" *ngIf="hideEditButton === false">
      <fcom-button
        #buttonComponent
        [size]="ButtonSize.MEDIUM"
        [theme]="passenger.completed ? ButtonTheme.LIGHT_SECONDARY_OUTLINE : ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
        [text]="(passenger.completed ? 'MMB.labels.updateDetails' : 'MMB.labels.addDetails') | finLocalization"
        (clickBtn)="openForm.emit({ passengerId: passenger.id, triggerElement: buttonComponent })"
      ></fcom-button>
    </div>
  </div>
</ng-container>
